export default __webpack_public_path__ + "static/media/puhelin-darkblue.620a779b.svg";